<app-section-header [title]="'Newsletter Management'">
  <div class="flex justify-end flex-1">
    <button
      mat-flat-button
      class="w-1/4 py-3 font-semibold text-white bg-project-2100"
      [routerLink]="['create']"
    >
      Create Newsletter
    </button>
  </div>
</app-section-header>
<div class="flex justify-end mt-4 space-x-3">
  <button mat-button color="primary" (click)="allNewsletter.openAll()">
    Expand All
  </button>
  <button mat-button color="primary" (click)="allNewsletter.closeAll()">
    Collapse All
  </button>
</div>
<mat-accordion multi class="mx-4" displayMode="flat">
  <mat-expansion-panel
    *ngFor="let newsletter of newsletterList$ | async"
    class="mb-4 mat-elevation-z0"
    [expanded]="expandSite === newsletter.region"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ newsletter.name }} ({{ newsletter.region }})
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <strong>Newsletters</strong>
      <div
        *ngFor="let category of newsletter.categories"
        class="flex flex-col py-6 space-y-5 border-b last:border-0"
      >
        <div class="grid grid-cols-4 gap-6">
          <div class="flex flex-col">
            <span class="text-project-1100">Id</span>
            <p>
              <a
                [routerLink]="[category.id]"
                [queryParams]="{ site: newsletter.region }"
                class="text-start"
                >{{ category.id }}</a
              >
            </p>
          </div>
          <div class="flex flex-col">
            <span class="text-project-1100">Name</span>
            <p>
              <a
                [routerLink]="[category.id]"
                [queryParams]="{ site: newsletter.region }"
                class="text-start"
                >{{ category.name }}</a
              >
            </p>
          </div>
          <div class="flex flex-col">
            <span class="text-project-1100">Description</span>
            <p>{{ category.description }}</p>
          </div>
          <div class="flex flex-col">
            <span class="text-project-1100">Is default</span>
            <p>{{ category.default }}</p>
          </div>
        </div>
        <div class="grid grid-cols-4">
          <div class="flex flex-col">
            <span class="text-project-1100">Frequecy</span>
            <p>{{ frequencies[category.frequency] }}</p>
          </div>
          <div class="flex flex-col" *ngIf="category.lowerFreqAlt?.length">
            <span class="text-project-1100">Lower Frequecy Alternatives</span>
            <div>
              Newsletter with Id:
              <a
                [routerLink]="[freqAlt]"
                [queryParams]="{ site: newsletter.region }"
                *ngFor="let freqAlt of category.lowerFreqAlt; let last = last"
              >
                {{ freqAlt }}{{ last ? "" : ", " }}</a
              >
            </div>
          </div>
          <div
            class="flex flex-col"
            *ngIf="
              category.lowerFreqAlt?.length && category.lowerFreqAltDefault
            "
          >
            <span class="text-project-1100"
              >Default Lower Frequecy Alternative</span
            >
            <p>
              Newsletter with Id:
              <a
                [routerLink]="[category.lowerFreqAltDefault]"
                [queryParams]="{ site: newsletter.region }"
                >{{ category.lowerFreqAltDefault }}</a
              >
            </p>
          </div>
          <div class="flex flex-col">
            <span class="text-project-1100">Created By</span>
            <p>{{ category.createdBy ?? "Unknown" }}</p>
          </div>
        </div>
        <div class="grid grid-cols-4">
          <div class="flex flex-col">
            <span class="text-project-1100">Updated By</span>
            <p>{{ category.updatedBy ?? "Unknown" }}</p>
          </div>
          <div class="flex flex-col">
            <span class="text-project-1100">Is special</span>
            <p>{{ category.special ?? false }}</p>
          </div>
          <div class="flex flex-col">
            <span class="text-project-1100">Is displayed once</span>
            <p>{{ category.displayOnce ?? false }}</p>
          </div>
          <div class="flex flex-col">
            <span class="text-project-1100">Image url</span>
            <p>{{ category.imageUrl ?? "-" }}</p>
          </div>
        </div>
      </div>
      <div *ngIf="newsletter.extraRegionGroups" class="mt-6">
        <strong>Extra region groups</strong>
        <div *ngFor="let extraRegionGroup of newsletter.extraRegionGroups">
          {{ extraRegionGroup }}
        </div>
      </div>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
